import classNames from 'classnames';
import React from 'react';

import allpatientsImage from '../../../../assets/images/Login/allpatientsImg.svg?url';
import styles from './index.module.scss';

export const PatientDataContent = () => (
  <div
    className={classNames(
      styles.contentDataContainer,
      'flex text-base font-normal text-neutrals-n-400 w-full items-start text-left gap-4',
    )}
  >
    <div className="w-1/2 flex justify-center">
      <img src={allpatientsImage} alt="allpatients" className={styles.allpatientImg} />
    </div>
    <div className="w-1/2">
      To review patient data on your computer go to{' '}
      <span className="font-bold">clinic.onestep.co.</span>
    </div>
  </div>
);
